export default __webpack_public_path__ + "static/feature2-c81142f8150503a2050b32dda742e7cd.webp";